import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "sameboard-container"
};
const _hoisted_2 = {
  class: "sameboard-main"
};
const _hoisted_3 = {
  key: 0,
  class: "loading-container"
};
const _hoisted_4 = {
  key: 1,
  class: "stock-list-container"
};
const _hoisted_5 = {
  class: "list-header"
};
const _hoisted_6 = {
  class: "list-header-right"
};
const _hoisted_7 = {
  class: "update-time"
};
const _hoisted_8 = ["value"];
const _hoisted_9 = {
  class: "stock-list"
};
const _hoisted_10 = {
  class: "rank-container"
};
const _hoisted_11 = {
  key: 0,
  class: "rank-change"
};
const _hoisted_12 = {
  class: "stock-info"
};
const _hoisted_13 = {
  class: "stock-name"
};
const _hoisted_14 = {
  class: "stock-code"
};
const _hoisted_15 = {
  class: "stock-tags"
};
const _hoisted_16 = {
  key: 0,
  class: "stock-description"
};
const _hoisted_17 = {
  class: "stock-data-right"
};
const _hoisted_18 = {
  class: "hotness"
};
import { ref, onMounted, onBeforeUnmount, watch } from 'vue';
export default {
  __name: 'SameBoard',
  setup(__props) {
    const stockList = ref([]);
    const loading = ref(true);
    const updateTime = ref('');
    const firstLoad = ref(true);
    const refreshOptions = [{
      value: 1
    }, {
      value: 5
    }, {
      value: 10
    }, {
      value: 30
    }, {
      value: 60
    }];
    const refreshInterval = ref(60);
    let timer = null;
    const fetchStockData = async (showLoading = false) => {
      if (showLoading) loading.value = true;
      try {
        const response = await fetch('https://dq.10jqka.com.cn/fuyao/hot_list_data/out/hot_list/v1/stock?stock_type=a&type=hour&list_type=normal');
        const data = await response.json();
        if (data && data.data && data.data.stock_list) {
          stockList.value = data.data.stock_list.map(item => {
            var _item$tag, _item$tag2;
            return {
              name: item.name,
              code: item.code,
              changePercent: item.rise_and_fall,
              hotness: (parseFloat(item.rate) / 10000).toFixed(1),
              tags: [...(((_item$tag = item.tag) === null || _item$tag === void 0 ? void 0 : _item$tag.concept_tag) || []), ...((_item$tag2 = item.tag) !== null && _item$tag2 !== void 0 && _item$tag2.popularity_tag ? [item.tag.popularity_tag] : [])],
              description: item.analyse || '',
              rankChange: item.hot_rank_chg !== 0 ? item.hot_rank_chg : null
            };
          });
          updateTime.value = data.data.update_time || '';
        } else {
          stockList.value = [];
          updateTime.value = '';
        }
      } catch (error) {
        console.error('获取股票数据失败:', error);
        stockList.value = [];
        updateTime.value = '数据加载失败';
      } finally {
        if (showLoading) loading.value = false;
        if (firstLoad.value) firstLoad.value = false;
      }
    };
    const setupTimer = () => {
      if (timer) clearInterval(timer);
      timer = setInterval(() => {
        fetchStockData(false);
      }, refreshInterval.value * 1000);
    };
    onMounted(() => {
      fetchStockData(true);
      setupTimer();
    });
    onBeforeUnmount(() => {
      if (timer) clearInterval(timer);
    });
    watch(refreshInterval, () => {
      setupTimer();
      fetchStockData(false);
    });
    const getRankClass = rank => {
      if (rank === 1) return 'rank-first';
      if (rank === 2) return 'rank-second';
      if (rank === 3) return 'rank-third';
      return 'rank-normal';
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("main", _hoisted_2, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[1] || (_cache[1] = [_createElementVNode("div", {
        class: "loading-spinner"
      }, null, -1), _createElementVNode("p", null, "正在加载同榜数据...", -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[2] || (_cache[2] = _createElementVNode("h2", null, null, -1)), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, _toDisplayString(updateTime.value), 1), _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => refreshInterval.value = $event),
        class: "refresh-select"
      }, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(refreshOptions, item => {
        return _createElementVNode("option", {
          key: item.value,
          value: item.value
        }, " 每" + _toDisplayString(item.value) + "秒刷新 ", 9, _hoisted_8);
      }), 64))], 512), [[_vModelSelect, refreshInterval.value]])])]), _createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stockList.value, (stock, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: stock.code || index,
          class: "stock-item"
        }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", {
          class: _normalizeClass(["rank-number", getRankClass(index + 1)])
        }, _toDisplayString(index + 1), 3), stock.rankChange !== null ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("span", {
          class: _normalizeClass(["change-arrow", {
            'change-up': stock.rankChange > 0,
            'change-down': stock.rankChange < 0
          }])
        }, null, 2), _createTextVNode(" " + _toDisplayString(Math.abs(stock.rankChange)), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, _toDisplayString(stock.name), 1), _createElementVNode("div", _hoisted_14, _toDisplayString(stock.code), 1), _createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(stock.tags, (tag, tagIndex) => {
          return _openBlock(), _createElementBlock("span", {
            key: tagIndex,
            class: _normalizeClass(["tag", {
              'tag-board': tag.includes('板')
            }])
          }, _toDisplayString(tag), 3);
        }), 128))]), stock.description ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(stock.description), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", {
          class: _normalizeClass(["change-percent", {
            'positive': stock.changePercent > 0,
            'negative': stock.changePercent < 0
          }])
        }, _toDisplayString(stock.changePercent > 0 ? '+' : '') + _toDisplayString(Number(stock.changePercent).toFixed(2)) + "% ", 3), _createElementVNode("div", _hoisted_18, _toDisplayString(stock.hotness) + "万热度", 1)])]);
      }), 128))])]))])]);
    };
  }
};